import React from 'react';

import { ActionIcon } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { DroxyDrawer } from 'components/Droxy/DroxyDrawer';
import { useChatMessageHandling } from 'hooks/use-chat-message-handling';
import { GitbookIcon } from 'hugeicons-react';
import { ResourcePlayground } from 'pages/ManageSmartAssistant/Playground/ResourcePlayground';
import { useTranslation } from 'react-i18next';

interface ResourcePlaygroundDrawerProps {
  resourceId: string;
  opened: boolean;
  onClose: () => void;
}

export function ResourcePlaygroundDrawer({ resourceId, opened, onClose }: ResourcePlaygroundDrawerProps) {
  const { t } = useTranslation();
  const chatHandling = useChatMessageHandling({ resourceId, type: 'RESOURCE' });

  const handleClose = () => {
    chatHandling.setNewConversation();
    onClose();
  };

  return (
    <DroxyDrawer
      opened={opened}
      onClose={handleClose}
      title={t('PLAYGROUND.RESOURCE.TITLE')}
      description={t('PLAYGROUND.RESOURCE.SUBTITLE')}
      additionalControls={
        <ActionIcon variant="subtle" onClick={chatHandling.setNewConversation}>
          <IconRefresh />
        </ActionIcon>
      }
      icon={<GitbookIcon height={25} width={25} />}>
      <ResourcePlayground resourceId={resourceId} chatHandling={chatHandling} />
    </DroxyDrawer>
  );
}
